
export const getDomain = (subDomain) => {
  let selectedDomain;
  let protocol;

  switch (subDomain) {
    case 'boat':
    case 'mango':
    case 'finolex':
      selectedDomain = 'eseal.io'; 
      protocol = 'https'; 
      break;
    default:
      selectedDomain = 'esealcom.com'; 
      protocol = 'http'; 
      break;
  }

  return `${protocol}://${subDomain}.${selectedDomain}`;
};


export const GoogleMapsAPI='AIzaSyCquxjb86AERsFjwQoYpne7hmErzfoCto4';
